module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "main-content--body"
  }, [_c('div', {
    staticClass: "wrapper-md"
  }, [_c('div', {
    staticClass: "main-content--panel"
  }, [(_vm.activity) ? _c('div', [_c('table', [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.activities), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(_vm._f("capitalize")(item.duration)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("capitalize")(item.reason)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.date))])])
  }))])]) : _c('div', [_vm._m(2)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "main-content--header"
  }, [_c('h4', [_vm._v("Activity")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Duration")]), _vm._v(" "), _c('th', [_vm._v("Reason")]), _vm._v(" "), _c('th', [_vm._v("Date")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "no-activity"
  }, [_c('h2', [_vm._v("Oops!")]), _vm._v(" "), _c('h3', [_vm._v("Nothing to see here!")]), _vm._v(" "), _c('h3', [_vm._v("Looks like you've never signed in to your team before.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-86728f68"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Activity.vue
// module id = 389
// module chunks = 1